import { render, staticRenderFns } from "./ChooseTemplate.vue?vue&type=template&id=630755e0"
import script from "./ChooseTemplate.vue?vue&type=script&lang=js"
export * from "./ChooseTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports